var map = {
	"./Basic_Python.json": 779,
	"./Data_Engineer.json": 18,
	"./Data_Science.json": 687,
	"./Deep_Learning.json": 135,
	"./Django_Part1.json": 90,
	"./Django_Part2.json": 160,
	"./Docker.json": 182,
	"./Fast_API.json": 899,
	"./Flask.json": 193,
	"./Git.json": 562,
	"./Jenkins.json": 96,
	"./Machine_Learning.json": 382,
	"./Python1.json": 283,
	"./Python2.json": 978,
	"./Python3.json": 685,
	"./Rest_API.json": 939
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35;